import * as React from "react";
import * as moment from "moment";
import "Loans/styles.scss";
import {connect} from "react-redux";
import {RouteComponentProps} from "react-router-dom";
import ContainerBox from "myshubhlife-component/container-box";
import BasicCard from "myshubhlife-component/card";
import Button from "myshubhlife-component/button";
import {imageBaseUrl} from "config";
import {Loan} from "Loans/interface";
import Rloc from "Loans/Rloc";
import {PaymentDetailsRoutes} from "Loans/routes";
import {setLoanIndex} from "Loans/actions";
import {CardRow} from "Loans/utils";
import {COLOR} from "utils/variables";
import {useEffect, useState} from "react";
import {getPreApprovedProductList} from "Loans/api";
import {preApprovedBanner} from "Loans/LoanList/PreApprovedBanner";
import {getIdToken} from "service";
import {setAndroidTokenAndVersionBeforeRedirecting} from "utils/android";
import {websiteUrl} from "config";

interface IConnectProps {
  dispatch?: (action: any) => void;
  isAndroid: boolean;
  loanList: Loan[];
  isPartnerAndroid?: boolean;
  authExt: any;
}

const LoanList = (props: IConnectProps & RouteComponentProps) => {
    const [preApprovedProductList, updatePreApprovedProductList] = useState<string[]>();

    useEffect(() => {
      if (props.loanList.length && props.authExt.hasOwnProperty("loanId")) {
        handleIndex(props.loanList.map((loan) => loan.loan_id).indexOf(Number(props.authExt["loanId"])), true);
      }
    }, [props.loanList]);

    const getPreApprovedProducts = async () => {
      try {
        updatePreApprovedProductList(await getPreApprovedProductList());
      } catch (error) {console.error()}
    };
    useEffect(() => {
      getPreApprovedProducts();
    }, []);

    const handleIndex = (index: number, replace?: boolean) => {
      props.dispatch(setLoanIndex(index));
      const pathname = `${props.location.pathname}/${PaymentDetailsRoutes.PAYMENT_DETAILS}`;
      if (replace) {
        return props.history.replace({pathname});
      }
      props.history.push({pathname});
    };

    return(
        <ContainerBox pageTitle={!props.isAndroid || props.isPartnerAndroid ? "Loans" : ""} showBackButton={true}>
          {!!preApprovedProductList?.length &&
          preApprovedBanner.hasOwnProperty(preApprovedProductList[preApprovedProductList.length - 1]) &&
            <div className="banner">
              <img className="width-full"
              onClick={() => {props.history.push("/loan-application")}}
              src={preApprovedBanner[preApprovedProductList
                [preApprovedProductList.length - 1]]}/>
            </div>
          }
          {
                props.loanList &&
                props.loanList.length === 0 &&
                <BasicCard>
                    <div className="no-loan-container">
                        <img src={`${imageBaseUrl}/img/icons/icon_no_loan.png`}
                             width={70}
                             alt="icon"
                        />
                        <p>You have no loans currently!</p>
                    </div>
                </BasicCard>
            }
            {
                props.loanList &&
                props.loanList.length > 0 &&
                props.loanList.sort((current: Loan, next: Loan) =>
                next.state['loan_detail']['loanDetail']['disbursalDate'] - current.state['loan_detail']['loanDetail']['disbursalDate']) &&
                props.loanList.map((info: Loan, index: number) => {
                    return(
                      <div key={index}>
                        {info.is_rloc ?
                          <Rloc rlocInfo={info} index={index}/> :
                          <BasicCard 
                            headerTitle={`${info.state.loan_detail.loanDetail.status?.split("_").join(" ")} LOAN`}
                            addtionalField={
                              <Button buttonText={"Details"}
                                maxWidth={95}
                                height={30}
                                bgColor={COLOR.WHITE}
                                textColor={COLOR.PRIMARY}
                                onClick={() => handleIndex(index)}
                              />
                            }
                          >
                            <div className="details-container">
                              <CardRow title="Amount" value={`₹ ${info.state['loan_detail']['loanDetail']['amount']}`}/>
                              <CardRow title="Tenure" value={`${info.state['loan_detail']['loanDetail']['tenureMonths']} Months`}/>
                              <CardRow
                                title="Emi start date"
                                value={
                                  info.state['loan_detail']['loanDetail']['emiStartDate'] ? 
                                  `${moment(Number(info.state['loan_detail']['loanDetail']['emiStartDate'])).format("LL")}` : "-"
                                  }
                              />
                            </div>
                          </BasicCard>
                        }
                      </div>
                    );
                })
            }
        </ContainerBox>
    );
};

const mapStateToProps = (state): IConnectProps => {
    return {
        isAndroid: state.login.isAndroid,
        loanList: state.loanDetails["loansList"] ? state.loanDetails["loansList"] : [],
        isPartnerAndroid: state.login.isPartnerAndroid,
        authExt: state.login.authExt,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(LoanList);
